export default "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <img [src]=\"lastUploadPhotoUrl\" />\r\n  </div>\r\n</div>\r\n";